var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        staticClass: "search-result-document",
        class: _vm.classes,
        attrs: {
          "data-bot": _vm.context
            ? "search-result__document--" + _vm.context
            : "search-result__document",
          href: _vm.link
        },
        on: {
          mouseenter: _vm.handleMouseEnter,
          mouseleave: function($event) {
            _vm.isHovered = false
          }
        }
      },
      _vm.$listeners
    ),
    [
      _c("CompassObject", {
        attrs: { size: "extra-small", type: "object", object: "document" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-result-document__content" },
        [
          _c("div", { staticClass: "search-result-document__title" }, [
            _c("h5", {
              staticClass:
                "search-result-document__name typographies-paragraph-medium-bold",
              domProps: { innerHTML: _vm._s(_vm.number) }
            }),
            _vm._v(" "),
            _vm.status
              ? _c(
                  "div",
                  { staticClass: "document-status" },
                  [
                    _c(
                      "CompassTag",
                      {
                        attrs: {
                          size: "small",
                          color: _vm.statusInformation.color,
                          icon: _vm.statusInformation.icon
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.status.label) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.checkDocumentDetails
            ? _c(
                "ul",
                {
                  staticClass:
                    "search-result-document__details typographies-paragraph-medium-regular"
                },
                [
                  _vm.checkRelatedObject
                    ? _c(
                        "li",
                        {
                          staticClass:
                            "typographies-paragraph-medium-semibold search-result-document__company"
                        },
                        [
                          _c("CompassLink", {
                            attrs: {
                              type: "secondary",
                              link: _vm.relatedObject.url
                            },
                            domProps: {
                              innerHTML: _vm._s(_vm.relatedObject.name)
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.amount.includes("undefined")
                    ? _c(
                        "li",
                        { staticClass: "search-result-document__amount" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.amount) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.name
                    ? _c(
                        "li",
                        { staticClass: "search-result-document__subject" },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.name) }
                          })
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.getHighlightedExtraFields, function(extraField, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "typographies-paragraph-medium-regular search-result-document__extra-field"
              },
              [
                _c("span", [_vm._v(" " + _vm._s(extraField.label))]),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(extraField.value) }
                })
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }